<template>
  <div class="bill-modal-order-list wrap-table-order" ref="orderList">
    <table class="table" :class="{ 'table-print-bill': true , 'table-voided': isBill('voided') }">
      <thead>
        <tr class="text-uppercase">
          <th v-translate>Qty</th>
          <th v-translate>Item</th>
          <th v-translate>Price / item</th>
          <th v-translate>Amount</th>
        </tr>
      </thead>
      <tbody>
        <template>
          <template v-for="(item, itemIndex) in previousOrder">
            <tr v-if="previousOrderSeparators.includes(itemIndex)" class="tr-grouped-separator">
              <td colspan="4" class="text-left">
                <strong>
                  <span v-translate>Order</span>: {{ printOrderNo(itemIndex) }} -
                  <span v-translate>Staff</span>: {{ printProperty(item.staff, 'staffs', 'ref') }} -
                  {{ $dayjs(item.createdDate).format('HH:mm') }}
                </strong>
              </td>
            </tr>
            <bill-item :item="item" :view="'modal'" />
            <bill-item-note :promotion="item.promotion" :view="'modal'" />
          </template>
          <tr class="tr-separator"><td colspan="4"></td></tr>
        </template>
      </tbody>
      <tfoot>
        <template v-for="payType in payTypes">
          <tr v-if="payType.name == 'subtotal' && getPayDetail(payType).total > payTotal">
            <td colspan="2" class="pay-type">{{ payType.name }}</td>
            <td colspan="2">{{ getPayDetail(payType).total | currency }}</td>
          </tr>
          <tr class="tr-separator" v-if="payType.name == 'total'">
            <td colspan="2" class="pt-2 pay-type">
              {{ payType.name }}
            </td>
            <td colspan="2" class="pt-2">{{ getPayDetail(payType).total | currency(true) }}</td>
          </tr>
          <tr class="tr-separator tr-total" v-if="payType.name == 'amount'">
            <td colspan="2" class="pay-type">{{ payType.name }}</td>
            <td colspan="2">
              <b v-if="isBill('voided')">0</b>
              <b v-else>{{ getPayDetail(payType).total | currency }}</b>
            </td>
          </tr>
          <tr v-if="payType.name == 'change'
                    && isBill('closed')
                    && Math.abs(getPayDetail(payType).total) != 0">
            <td colspan="2" class="pt-1 pay-type">{{ payType.name }}</td>
            <td colspan="2" class="pt-1">{{ Math.abs(getPayDetail(payType).total) | currency }}</td>
          </tr>
          <tr v-if="!isSpecialPayType(payType.name)
                    && getPayDetail(payType)
                    && getPayDetail(payType).total > 0
                    && !getPayDetail(payType).hideOnBill">
            <td colspan="2" class="pay-type">
              {{ payType.name }}&nbsp;
              <b v-if="getPayDetail(payType).payValue*1 > 0">
                ({{ getPayDetail(payType).payValue }}%)
              </b>
              <b v-if="getPayDetail(payType).includeOnPrice">
                (<translate>Included in price</translate>)
              </b>
            </td>
            <td colspan="2" v-if="payType.isVat">{{ getPayDetail(payType).total | currency(true) }}</td>
            <td colspan="2" v-else>{{ getPayDetail(payType).total | currency }}</td>
          </tr>
        </template>
      </tfoot>
    </table>
  </div>
  <!-- /.wrap-table-order -->
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BillItem from '@/components/BillItem';
import BillItemNote from '@/components/BillItemNote.vue';

export default {
  name: 'OrderListModal',
  components: {
    BillItem,
    BillItemNote,
  },
  data() {
    return {
      specialPayTypes: ['subtotal', 'total', 'amount', 'change']
    };
  },
  computed: {
    payTotal() {
      const totalPayType = this.payTypes.find(payType => payType.name == 'total');
      return this.payDetails.find(payDetail => payDetail.payType == totalPayType.id).total;
    },
    payDetails() { return this.getMap('bill', true).payDetails },
    payTypes() {
      return this
              .getArray('payTypes')
              .sort((a, b) => a.indexNumber > b.indexNumber ? 1 : -1)
    },
    previousOrder() {
      return this.getMap('previousOrder', true) ;
    },
    ...mapGetters(['previousOrderSeparators', 'isBill', 'getPayDetail']),
  },
  methods: {
    isSpecialPayType(payType) {
      return this.specialPayTypes.indexOf(payType) != -1;
    },
    printOrderNo(itemIndex) {
      const foundIndex = this.previousOrderSeparators.findIndex(i => itemIndex < i);

      if (foundIndex > 0) {
        return foundIndex;
      }

      return this.previousOrderSeparators.length;
    },
  }
};
</script>

<style lang="scss" scoped>
.bill-modal-order-list.wrap-table-order {
  height: 100%;
  margin-bottom: 0;
  overflow: hidden;

  .table-print-bill {
    display: flex;
    flex-direction: column;
    height: 100%;
    table-layout: fixed;
    width: 100%;
    margin-bottom: 0;

    thead,
    tfoot {
      display: table;
      width: 100%;
      table-layout: fixed;
    }

    tbody {
      display: block;
      flex: 1 1 auto;
      min-height: 0;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;
      }
    }
  }
}

@media print {
  .bill-modal-order-list {
    height: auto;
    overflow: visible;

    .table-print-bill {
      display: table;
      height: auto;

      thead {
        display: table-header-group;
      }

      tbody {
        display: table-row-group;
        max-height: none;
        overflow: visible;
      }

      tfoot {
        display: table-footer-group;
      }

      tbody tr {
        display: table-row;
        width: auto;
      }
    }
  }
}
</style>
